<template>
  <DropdownMenuRoot v-model:open="isOpen">
    <DropdownMenuTrigger
      :aria-label="$t('channel.contests.dropdown.aria')"
      :class="$attrs.class"
    >
      <Icon
        icon="ph:dots-three"
        class="rounded-full flex items-center justify-center bg-brand-bgdivider-20 text-lg hover:text-basics-tertiary-60 p-6u text-basics-secondary-80 size-8"
      />
    </DropdownMenuTrigger>

    <DropdownMenuPortal :to="portalRootElementSelector">
      <DropdownMenuContent
        class="outline-none shadow bg-brand-bgdivider-20 text-brand-tertiary-60 backdrop-blur-3xl p-2 rounded-xl will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade z-[999999999999]"
        :side-offset="5"
      >
        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary text-brand-primary data-[highlighted]:text-text rounded-md px-2 py-2.5 gap-2"
          @click="emit('edit')"
        >
          <Icon icon="material-symbols:edit" width="24" height="24" />
          {{ $t("channel.contests.dropdown.edit", { type: objectName }) }}
        </DropdownMenuItem>

        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary data-[highlighted]:text-text text-basics-accent-red rounded-md px-2 py-2.5 gap-2"
          @click="emit('delete')"
        >
          <Icon icon="ph:trash" width="24" height="24" />
          {{ $t("channel.contests.dropdown.delete", { type: objectName }) }}
        </DropdownMenuItem>

        <ContestTooltip side="bottom" :disabled="isShareEnabled">
          <template #trigger>
            <DropdownMenuItem
              as="button"
              class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary text-brand-primary disabled:text-brand-secondary-80 data-[highlighted]:text-text rounded-md px-2 py-2.5 gap-2"
              :disabled="!isShareEnabled"
              @click="isShareEnabled && emit('share')"
            >
              <Icon icon="mdi:ios-share" width="24" height="24" />
              {{ $t("channel.contests.dropdown.share", { type: objectName }) }}
            </DropdownMenuItem>
          </template>
          <p>
            <span>{{ $t("channel.contests.dropdown.draftShare") }}</span>
          </p>
        </ContestTooltip>

        <DropdownMenuArrow class="fill-brand-bgdivider-20 backdrop-blur-3xl" />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>

<script setup lang="ts">
import { portalRootElementSelector } from "@/constants/ui";
import { useChannelStore } from "@/stores/channel.store";
import { Icon } from "@iconify/vue";

import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from "reka-ui";
import { ref } from "vue";
import ContestTooltip from "@/components/show/producer-controls/contests/components/contest-tooltip.vue";

const _channelStore = useChannelStore();

defineProps<{
  objectName: string;
  isShareEnabled: boolean;
}>();

const emit = defineEmits<{
  delete: [];
  edit: [];
  share: [];
}>();

const isOpen = ref(false);
</script>
